<template>
    <span class="product_full-gallery">
      <div class="primary-image">
        <lazy-img :src="mainImage"></lazy-img>
      </div>
      <div class="variant-images">
        <span v-for="(image, i) of images" v-on:click="setPrimary(i)" :key="i">
          <lazy-img class="variant-image" :src="image.variants['96']"></lazy-img>
        </span>
      </div>
    </span>
</template>

<script>


  export default {
    name: "product-gallery",
    data() {
      return {
        mainImage: null
      }
    },
    props: {
      images: null
    },
    created() {
    },
    mounted() {
      if(this.images.length > 0)
        this.mainImage = this.images[0].variants['512']
    },
    watch: {
      images: function (to) {
        this.images = to;
      }
    },
    methods: {
      setPrimary(index){
        this.images.forEach((img, i) => {
          if(index == i) this.mainImage = img.variants['512'];
        });
      }
    }
  }
</script>

<style lang="scss">
  .lazy-image-placeholder {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .primary-image .lazy-image {
    max-width: 100% !important;
  }
  .variant-images {
    margin-top: 10px;
    margin-right: 36px;
    width: 380px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: start;
  }
  .variant-images span {
    cursor: pointer;
  }
  .variant-images .lazy-image {
    width: 60px !important;
    margin: 0 10px;
  }
  .variant-images .lazy-image-wrapper, .variant-images .lazy-image-main {
    display: inline-block;
    max-width: 60px;
  }
  .variant-images .variant-image {
    max-width: 60px;
  }
  .product_full-gallery {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .primary-image {
    width: 380px;
    margin-right: 36px;
  }
  @media only screen and (max-width: 767.98px) and (min-width: 481px){
    .primary-image {
      width: 305px;
      margin-right: 15px;
    }
    .variant-images {
      width: 100%;
      margin-right: 0;
    }

  }
  @media only screen and (max-width: 480.98px){
    .product_full-gallery {
      display: block;
    }
    .primary-image {
      width: 100%!important;
    }
    .variant-images {
      width: 100%;
      margin-right: 0;
    }
    .product-tags {
      text-align: center;
    }

  }
</style>
